class manualContactModal {
    constructor($scope, httpRequest, $uibModalInstance, $filter, items1, logger) {
        $scope.selectedRows = []
        httpRequest.get_dictByTypeArr(['ivat_orig_inv_type']).then((res) => {
            $scope.dictData = res.data.value
        })
        $scope.reset = function () {
            $scope.queryParam = {
                pageNum: 1,
                pageSize: 5,
                param: {
                    electricInvoiceNum: '',
                    invoiceDateBegin: '',
                    invoiceDateEnd: '',
                    custName: items1.custName,
                    invoiceId: items1.invoiceId,
                    invType: items1.invType,
                    // invoiceDateBegin: `${new Date().getFullYear()}-${new Date().getMonth() + 1}-01`,
                    // invoiceDateEnd: $filter('date')(new Date(), 'yyyy-MM-dd'),
                },
            }
        }

        $scope.selectedHandle = function selectedHandle() {
            $scope.queryParam.orderMap = $scope.orderMap.wrap

            $scope.queryList()
        }

        // 增加排序功能
        $scope.orderMap = {
            sortKey: 'invoiceDate',
            sortVal: 'desc',
        }

        $scope.queryList = function () {
            $scope.selectedRows = []
            httpRequest.post_pageOpenedInvoiceMain($scope.queryParam).then((res) => {
                $scope.totalItems = res.data.value.total
                $scope.listData = res.data.value.list
            })
        }

        $scope.searchList = function () {
            $scope.queryParam.pageNum = 1
            $scope.queryList()
        }
        $scope.reset()
        $scope.searchList()
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }
        $scope.ok = function () {
            if (!$scope.selectedRows.length) {
                return logger.logError('请选择要手工关联的数据')
            }
            if ($scope.selectedRows.length > 1) {
                return logger.logError('只能选择一条数据进行关联')
            }
            $uibModalInstance.close($scope.selectedRows[0])
        }
    }
}
manualContactModal.$inject = ['$scope', 'httpRequest', '$uibModalInstance', '$filter', 'items1', 'logger']
export default manualContactModal



// WEBPACK FOOTER //
// ./src/app/outputManage/fullElectricInvoice/fullEleInvoice/manualContactModal.js